<template>
  <AppLayout>
    <VFlex xs12>
      <h1 class="primary--text mb-4">
        {{ $nt('createCustomer') }}
      </h1>
      <VCard>
        <VCardText>
          <VForm
            ref="form"
            v-model="isFormValid"
          >
            <VSubheader>{{ $nt('user') }}</VSubheader>

            <VLayout wrap>
              <VFlex row>
                <VTextField
                  v-model="companyCreationObj.user_first_name"
                  class="mx-3"
                  :error-messages="errorMessages.user_first_name"
                  :label="$nt('firstName')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex>
                <VTextField
                  v-model="companyCreationObj.user_last_name"
                  class="mx-3"
                  :error-messages="errorMessages.user_last_name"
                  :label="$nt('lastName')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="companyCreationObj.user_email"
                  class="mx-3"
                  :error-messages="errorMessages.user_email"
                  :label="$nt('email')"
                  :rules="[$rules.isRequired, $rules.isValidEmail]"
                />
              </VFlex>
            </VLayout>
            <VDivider />
            <VSubheader>{{ $nt('company') }}</VSubheader>
            <VLayout wrap>
              <VFlex xs12>
                <VTextField
                  v-model="companyCreationObj.company_name"
                  class="mx-3"
                  :error-messages="errorMessages.company_name"
                  :label="$nt('companyName')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex>
                <SelectCity
                  :value="companyCreationObj.company_city_id"
                  class="mx-3"
                  :rules="[$rules.isRequired]"
                  :error-messages="errorMessages.company_city_id"
                  @input="({id}) => Object.assign(companyCreationObj, {company_city_id: id})"
                />
              </VFlex>
              <VFlex>
                <VTextField
                  v-model="companyCreationObj.company_street"
                  class="mx-3"
                  :error-messages="errorMessages.company_street"
                  :label="$nt('companyStreet')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="companyCreationObj.company_phone"
                  class="mx-3"
                  :error-messages="errorMessages.company_phone"
                  :label="$nt('companyPhone')"
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="companyCreationObj.company_email"
                  class="mx-3"
                  :error-messages="errorMessages.company_email"
                  :label="$nt('email')"
                  :rules="[$rules.isRequired, $rules.isValidEmail]"
                />
              </VFlex>
            </VLayout>
          </VForm>
        </VCardText>
        <VCardActions>
          <VSpacer />
          <VBtn
            color="primary"
            :loading="isLoading"
            :disabled="isValid || isLoading"
            @click="createAgency"
          >
            {{ $nt('add') }}
          </VBtn>
        </VCardActions>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
import AgentApi from '@/api/AgentApi'
import SelectCity from '@/components/global-components/inputs/SelectCity'

export default {
  name: 'ContractCreate',
  components: { SelectCity },
  data () {
    return {
      isFormValid: false,
      dialog: false,
      companyCreationObj: {
        user_first_name: '',
        user_last_name: '',
        user_email: '',
        company_name: '',
        company_street: '',
        company_city_id: null,
        company_phone: '',
        company_email: ''
      },
      isLoading: false,
      errorMessages: {}
    }
  },
  computed: {
    isValid () {
      return !this.isFormValid && Object.getOwnPropertyNames(this.errorMessages).length === 1
    }
  },
  methods: {
    async createAgency () {
      if (!this.isValid) {
        this.isLoading = true
        try {
          const result = await AgentApi.createCompany(this.companyCreationObj)
          this.$router.push({ name: 'contract', params: { contractId: result.id } })
        } catch (e) {
          this.errorMessages = e.errors
        }
        this.isLoading = false
      }
    }
  }
}
</script>
